import { createContext, useContext } from 'react'
import { Platform } from 'react-native'
import { colors } from '@ui/colors'
import { TypographyVariant } from '@ui/typography/types'

export const lineVariant: TypographyVariant = Platform.select({
  default: 'SM',
  web: 'MD',
})

interface TextPaperContextValue {
  lineColor: string
  lineVariant: TypographyVariant
}

export const TextPaperContext = createContext<TextPaperContextValue>({
  lineColor: colors.text50,
  lineVariant,
})

export const useTextPaperContext = () => useContext(TextPaperContext)
